import { typography } from '@dentalux/ui-library-core'
import { createUseStyles } from 'react-jss'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  iconWithTextWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: 314,
    marginBottom: 16,
  },
  textStyles: {
    ...typography['Lato Emphasized 1'],
    display: 'flex',
    flexDirection: 'column',
  },
  timeStyles: {
    ...typography['Lato Body 2'],
    marginTop: 4,
  },
  iconStyles: {
    width: 48,
    height: 48,
    marginRight: 16,
    color: theme.palette.primary.main,
  },
  address: {
    ...typography['Lato Body 2'],
    marginTop: 6,
  },
  phone: {
    ...typography['Lato Link 2'],
    cursor: 'pointer',
    marginTop: 6,
  },
  warningContainer: {
    marginTop: 32,
  },
  warningDescriptionContainer: {
    ...typography['Lato Body 1'],
  },
  warningCheckboxContainer: {
    marginTop: 16,
    padding: '8px 0',
    display: 'flex',
    alignItems: 'center',
  },
  warningCheckboxLabel: {
    ...typography['Lato Body 2'],
    cursor: 'pointer',
  },
  warningCheckbox: {
    marginRight: 11,
    marginLeft: 3,
  },
}))
